import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { withRouter } from "../../../withRouter";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import InfoTooltip from "../infoTooltip/InfoTooltip";
import Utils from "../../../provider/Utils";
import FetchServerData from "../../../provider/FetchServerData";
import PtsAlert from "../ptsAlert/PtsAlert";
import store from "../../../redux/store";
import ToggleButton from "@mui/material/ToggleButton";
import BackButton from "../buttons/BackButton";
import SaveButton from "../buttons/SaveButton";
import CancelIconButton from "../buttons/CancelIconButton";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Autocomplete } from "@mui/material";
import "./UserManagement.css";
// import Checkbox from "@material-ui/core/Checkbox";
// import FormControlLabel from "@material-ui/core/FormControlLabel";
// import CreateButton from "../buttons/CreateButton";
// import PasswordRequirementsTooltip from "../passwordRequirementsTooltip/passwordRequirementsTooltip";
import debounce from "lodash.debounce";
import UserManagementList from "./UserManagementList";
import EditIconButton from "../buttons/EditIconButton";
// import DeleteIconButton from "../buttons/DeleteIconButton";
import Button from "@material-ui/core/Button";
import CheckIcon from "@mui/icons-material/Check";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";
import { Col, Row } from "reactstrap";
import {
  CreateUser_Url,
  DeleteUser_Url,
  GetUser_Url,
  UpdateUser_Url,
} from "../../../provider/ServiceUrl";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";

class UserManagement extends Component {
  addressRef = React.createRef();
  header = store.getState().header.header;
  countryListArray = store.getState().staticData.countryList;
  defaultCountry = store.getState().staticData.defaultCountry;
  profile = store.getState().appUserData.appUserData.appuser?.profile;
  appuser = store.getState().appUserData.appUserData.appuser;
  businessDomain = store.getState().appUserData.appUserData.appuser?.businessDomain;
  constructor(props) {
    super(props);
    let action = props.action;
    let userId = props.userId;
    let userProfileList = props.profileList;
    if (!action && props.state) {
      action = props.state.action;
      userId = props.state.userId;
      userProfileList = props.state.profileList;
    }
    if (
      action &&
      Utils.equalsIgnoreCase(
        action,
        "view" || Utils.equalsIgnoreCase(action, "update")
      )
    ) {
      this.getUserDetails(userId);
    }
    this.state = {
      action: action,
      userId: userId,
      userProfileList: userProfileList,
      countryCode:
        this.defaultCountry !== null
          ? `+${this.defaultCountry?.phoneCode}`
          : "",
      officeCountryCode:
        this.defaultCountry !== null
          ? `+${this.defaultCountry?.phoneCode}`
          : "",
      address: {},
      firstName: "",
      lastName: "",
      phone: "",
      phoneNo: "",
      officePhone: "",
      officePhoneNo: "",
      panno: "",
      designation: "",
      email: "",
      password: "",
      confirmPassword: "",
      showPassword: false,
      showConfirmPassword: false,
      userProfile: null,
      enablemobileaccess: true,
      isSendReceipt: false,
      isStatus: true,
      render: false,
      getUpdatePermission: false,
      getDeletePermission: false,
      passwordFocussed: false,
      passwordHelperText: "",
      errorMessageText: "",
      confirmPasswordHelperText: "",
      isPwdresetRequested: false,
      sendOtpByEmail: false,
      sendOtpByText: true,
      isHovered: false,
      isRegistered: false,
      userDeleteConfirmOpen: false,
      showDeleteConfirmpassword: false,
      isMakePrimaryRequested: false,
      deleteConfirmpassword: "",
      sendverificationCodeList: [{ name: "SMS", sendOtpByText: true, sendOtpByEmail: false, id: 1 }, { name: "Email", sendOtpByText: false, sendOtpByEmail: true, id: 2 }, { name: "SMS and Email", sendOtpByText: true, sendOtpByEmail: true, id: 3 }],
      sendverificationCode: { name: "SMS", sendOtpByText: true, sendOtpByEmail: false, id: 1 },
    };
  }
  getUserDetails(userId) {
    const postObject = {
      header: this.header,
      appuser: {
        id: userId,
      },
    };
    FetchServerData.callPostService(GetUser_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let userDetails = output.data.appuser;
          let getPermission = Utils.getRolePermission(
            output.data?.privilegeList
          );
          let getUpdatePermission = getPermission[3];
          let getDeletePermission = getPermission[4];
          let userStatus = "";
          if (userStatus === null) {
            userStatus = false;
          } else {
            if (userDetails.appuserStatus?.status === "Active") {
              userStatus = true;
            } else {
              userStatus = false;
            }
          }
          let phoneNo =
            userDetails?.phone !== null
              ? Utils.phoneNumberFormate(userDetails?.phone)
              : "";
          let officePhoneNo =
            userDetails?.officePhone !== null
              ? Utils.phoneNumberFormate(userDetails?.officePhone)
              : "";
          let sendverificationCode = null
          if (userDetails.sendOtpByEmail && userDetails.sendOtpByText) {
            sendverificationCode = {
              name: "SMS and Email",
              sendOtpByText: true,
              sendOtpByEmail: true,
              id: 3
            };
          } else if (userDetails.sendOtpByText) {
            sendverificationCode = {
              name: "SMS",
              sendOtpByText: true,
              sendOtpByEmail: false,
              id: 1
            };
          } else if (userDetails.sendOtpByEmail) {
            sendverificationCode = {
              name: "Email",
              sendOtpByText: false,
              sendOtpByEmail: true,
              id: 2
            };
          }
          this.setState({
            render: true,
            action: "view",
            id: userDetails.id,
            firstName: userDetails.firstName,
            lastName: userDetails.lastName,
            uid: userDetails.uid,
            email: userDetails.email,
            countryCode: userDetails.phoneCountrycode,
            officeCountryCode: userDetails.officePhoneCountrycode,
            phone: userDetails?.phone,
            phoneNo: phoneNo,
            officePhoneNo: officePhoneNo,
            officePhone: userDetails?.officePhone,
            jobTitle: userDetails.jobTitle,
            designation: userDetails.designation,
            enablemobileaccess: userDetails.enablemobileaccess,
            isRegistered: userDetails.isRegistered,
            isSendReceipt: userDetails.isSendReceipt,
            sendOtpByEmail: userDetails.sendOtpByEmail,
            sendOtpByText: userDetails.sendOtpByText,
            sendverificationCode: sendverificationCode,
            address: userDetails.address,
            userProfile: userDetails.profile,
            isStatus: userStatus,
            userStatus: userDetails.appuserStatus?.status,
            isPwdresetRequested: userDetails.isPwdresetRequested,
            isMakePrimaryRequested: userDetails.isMakePrimaryRequested,
            getUpdatePermission: getUpdatePermission,
            getDeletePermission: getDeletePermission,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  toggleFocusNewPassword = () => {
    this.setState((prevState) => {
      return { passwordFocussed: !prevState.passwordFocussed };
    });
  };

  handleClickShowConfirmPassword() {
    this.setState({ showConfirmPassword: !this.state.showConfirmPassword });
  }

  handlePasswordChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
    if (name === "password") {
      this.debouncedValidatePassword(value);
    } else if (name === "confirmPassword") {
      this.debouncedValidatePassword(this.state.password);
    }
    // this.setState({ password: e.target.value });
  };
  handleClickShowPassword() {
    this.setState({ showPassword: !this.state.showPassword });
  }
  debouncedValidatePassword = debounce(
    (password) => this.validatePassword(password),
    1000
  );
  validatePassword = (password) => {
    const { confirmPassword } = this.state;
    let one = false,
      two = false,
      three = false,
      four = false,
      five = false,
      confirmPasswordHelperText = "";

    if (password.length < 12) {
      one = true;
    }
    if (!password.match(/[A-Z]/)) {
      two = true;
    }
    if (!password.match(/[a-z]/)) {
      three = true;
    }
    if (!password.match(/[\d]/)) {
      four = true;
    }
    if (!password.match(/[\W]/)) {
      five = true;
    }
    if (password !== confirmPassword) {
      confirmPasswordHelperText = "Password & confirm password must match";
    }

    if (one || two || three || four || five) {
      this.setState({
        error: { one: one, two: two, three: three, four: four, five: five },
        confirmPasswordHelperText: confirmPasswordHelperText,
        passwordHelperText: "Password requirements not met",
      });
      return;
    }

    this.setState({
      disable: false || password !== confirmPassword,
      error: {},
      confirmPasswordHelperText: confirmPasswordHelperText,
      passwordHelperText: "",
    });
  };

  handleStatusChange(e) {
    this.setState({ isStatus: !this.state.isStatus });
  }

  handlePasswordConfirmChange(e) {
    this.setState({ confirmPassword: e.target.value });
  }
  handleFirstNameChange(e) {
    this.setState({ firstName: e.target.value });
  }
  handleLastNameChange(e) {
    this.setState({ lastName: e.target.value });
  }

  handleCountryChange(phone, country, e, formattedValue) {
    this.setState({
      countryCode: formattedValue,
    });
  }
  handleOfficeCountryChange(phone, country, e, formattedValue) {
    this.setState({
      officeCountryCode: formattedValue,
    });
  }

  handlePhoneChange(e) {
    let val = e.target.value;
    if (val.length <= 12) {
      let value = Utils.phoneNumberFormate(val);
      this.setState({
        phoneNo: value,
        phone: e.target.value.replace(/-/g, ""),
      });
    }
  }

  handleOfficePhoneChange(e) {
    let val = e.target.value;
    if (val.length <= 12) {
      let value = Utils.phoneNumberFormate(val);
      this.setState({
        officePhoneNo: value,
        officePhone: e.target.value.replace(/-/g, ""),
      });
    }
  }

  handlePanNoChange(e) {
    this.setState({ panno: e.target.value });
  }

  handleAdharNoChange(e) {
    let res = e.target.value;
    if (res.length <= 12) {
      this.setState({ adhar: res });
    } else {
      Utils.maxFieldLength(12);
    }
  }
  handleEmailChange(e) {
    this.setState({ email: e.target.value, uid: e.target.value });
  }

  handleJobTitleChange(e) {
    this.setState({ jobTitle: e.target.value });
  }

  handleUserIDChange(e) {
    this.setState({ uid: e.target.value });
  }
  handleUserProfileChange(selectedValue) {
    this.setState({ userProfile: selectedValue });
  }
  handleEnableMobileAccessChange(e) {
    this.setState({ enablemobileaccess: !this.state.enablemobileaccess });
  }
  handleIsSendReceiptChange(e) {
    this.setState({ isSendReceipt: !this.state.isSendReceipt });
  }

  createUserToBackend() {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (this.state.email && !emailRegex?.test(this.state.email)) {
      PtsAlert.error("Email id is not valid");
      return;
    }
    const postObject = {
      header: this.header,
      appuser: {
        uid: this.state.uid,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        email: this.state.email,
        phoneCountrycode: this.state.countryCode,
        phone: this.state.phone,
        officePhoneCountrycode: this.state.officeCountryCode,
        officePhone: this.state.officePhone,
        jobTitle: this.state.jobTitle,
        // credential: this.state.password,
        tenant: this.header.tid,
        enablemobileaccess: this.state.enablemobileaccess,
        isSendReceipt: this.state.isSendReceipt,
        // isRegistered: this.state.isRegistered,
        sendOtpByEmail: this.state.sendverificationCode?.sendOtpByEmail,
        sendOtpByText: this.state.sendverificationCode?.sendOtpByText,
        // address: {
        //   line: this.addressRef.current.state.line,
        //   state: {
        //     name: this.addressRef.current.state.state.name,
        //     code: this.addressRef.current.state.state.code,
        //     id: this.addressRef.current.state.state.id,
        //     country: {
        //       name: this.addressRef.current.state?.country?.name,
        //       code: this.addressRef.current.state?.country?.code,
        //       isocode: this.addressRef.current.state?.country?.isocode,
        //       namecode: this.addressRef.current.state?.country?.namecode,
        //       id: this.addressRef.current.state?.country?.id,
        //     },
        //   },
        //   city: this.addressRef.current.state.city,
        //   zipcode: this.addressRef.current.state.zipCode,
        // },
        profile: {
          name: this.state.userProfile?.name,
          id: this.state.userProfile?.id,
        },
      },
    };
    FetchServerData.callPostService(CreateUser_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let userData = output.data.appuser;
          this.getUserDetails(userData.id);
          this.setState({
            action: "view",
          });
        } else {
        }
      }
    );
  }
  createCancel() {
    this.setState({
      action: "userList",
    });
  }
  viewCancel() {
    this.setState({
      action: "userList",
    });
  }
  editCancel() {
    this.getUserDetails(this.state.id);
  }
  handleAddressChange(address) {
    this.setState({ address: address });
  }

  editUserDetails(e) {
    this.setState({ action: "edit", userId: this.state.id });
  }

  updateUserToBackend() {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (this.state.email && !emailRegex?.test(this.state.email)) {
      PtsAlert.error("Email id is not valid");
      return;
    }

    let userStatus;
    if (this.state.isStatus === true) {
      userStatus = "Active";
    } else {
      userStatus = "Inactive";
    }
    const postObject = {
      header: this.header,
      appuser: {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        email: this.state.email,
        phoneCountrycode: this.state.countryCode,
        phone: this.state.phone,
        officePhoneCountrycode: this.state.officeCountryCode,
        officePhone: this.state.officePhone,
        jobTitle: this.state.jobTitle,
        tenant: this.header.tid,
        enablemobileaccess: this.state.enablemobileaccess,
        isSendReceipt: this.state.isSendReceipt,
        isRegistered: this.state.isRegistered,
        id: this.state.userId,
        sendOtpByEmail: this.state.sendverificationCode?.sendOtpByEmail,
        sendOtpByText: this.state.sendverificationCode?.sendOtpByText,
        // address: {
        //   id: this.addressRef.current.state.id,
        //   line: this.addressRef.current.state.line,
        //   state: {
        //     name: this.addressRef.current.state.state.name,
        //     code: this.addressRef.current.state.state.code,
        //     id: this.addressRef.current.state.state.id,
        //     country: {
        //       name: this.addressRef.current.state?.country?.name,
        //       code: this.addressRef.current.state?.country?.code,
        //       isocode: this.addressRef.current.state?.country?.isocode,
        //       namecode: this.addressRef.current.state?.country?.namecode,
        //       id: this.addressRef.current.state?.country?.id,
        //     },
        //   },
        //   city: this.addressRef.current.state.city,
        //   zipcode: this.addressRef.current.state.zipCode,
        // },
        appuserStatus: {
          status: userStatus,
        },
        profile: {
          name: this.state.userProfile?.name,
          id: this.state.userProfile?.id,
        },
      },
    };
    FetchServerData.callPostService(UpdateUser_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let userData = output.data.appuser;
          this.getUserDetails(userData.id);
          this.setState({
            action: "view",
          });
        } else {
        }
      }
    );
  }

  deleteUserToBackend() {
    const postObject = {
      header: this.header,
      appuser: {
        id: this.state.id,
      },
      confirm: this.state.deleteConfirmpassword,
    };

    FetchServerData.callPostService(DeleteUser_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          if (this.appuser?.email === this.state.email) {
            this.props.navigate("/");
          } else {
            this.setState({
              action: "userList",
            });
          }

        } else {
        }
      })
      .catch((error) => { });
  }

  handleSendOtpByEmailChange(e) {
    this.setState({ sendOtpByEmail: e.target.checked, error: false });
  }
  handleSendOtpByTextChange(e) {
    this.setState({ sendOtpByText: e.target.checked, error: false });
  }

  handleSendverificationCodeChange(selectedValue) {
    this.setState({ sendverificationCode: selectedValue, error: false });
  }

  handlePwdresetRequestedChange(e) {
    this.userReqestPwdReset(e.target.checked);
    this.setState({ enableMms: e.target.checked });
    this.setState({ isPwdresetRequested: !this.state.isPwdresetRequested });
  }
  userReqestPwdReset(isPwdresetRequested) {
    const postObject = {
      header: this.header,
      appuser: {
        id: this.state.id,
        isPwdresetRequested: isPwdresetRequested,
      },
    };
    FetchServerData.callPostService("/appuserms/requestPwdReset", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let userDetails = output.data.appuser;
          let getPermission = Utils.getRolePermission(
            output.data?.privilegeList
          );
          let getUpdatePermission = getPermission[3];
          let getDeletePermission = getPermission[4];
          let userStatus = "";
          if (userStatus === null) {
            userStatus = false;
          } else {
            if (userDetails.appuserStatus?.status === "Active") {
              userStatus = true;
            } else {
              userStatus = false;
            }
          }
          let phoneNo =
            userDetails?.phone !== null
              ? Utils.phoneNumberFormate(userDetails?.phone)
              : "";
          let officePhoneNo =
            userDetails?.officePhone !== null
              ? Utils.phoneNumberFormate(userDetails?.officePhone)
              : "";
          this.setState({
            render: true,
            action: "view",
            id: userDetails.id,
            firstName: userDetails.firstName,
            lastName: userDetails.lastName,
            uid: userDetails.uid,
            email: userDetails.email,
            countryCode: userDetails.phoneCountrycode,
            officeCountryCode: userDetails.officePhoneCountrycode,
            phone: userDetails?.phone,
            phoneNo: phoneNo,
            officePhoneNo: officePhoneNo,
            officePhone: userDetails?.officePhone,
            jobTitle: userDetails.jobTitle,
            designation: userDetails.designation,
            enablemobileaccess: userDetails.enablemobileaccess,
            isSendReceipt: userDetails.isSendReceipt,
            sendOtpByEmail: userDetails.sendOtpByEmail,
            sendOtpByText: userDetails.sendOtpByText,
            address: userDetails.address,
            userProfile: userDetails.profile,
            isStatus: userStatus,
            userStatus: userDetails.appuserStatus?.status,
            isPwdresetRequested: userDetails.isPwdresetRequested,
            getUpdatePermission: getUpdatePermission,
            getDeletePermission: getDeletePermission,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  handleUserDeleteConfirmOpen() {
    this.setState({
      userDeleteConfirmOpen: true,
    })
  }
  handleUserDeleteConfirmClose() {
    this.setState({
      userDeleteConfirmOpen: false,
    })
  }

  handleUserDeleteConfirmPasswordChange(e) {
    this.setState({ deleteConfirmpassword: e.target.value });
  }

  handleUserDeleteConfirmClickShowPassword() {
    this.setState({ showDeleteConfirmpassword: !this.state.showDeleteConfirmpassword });
  }

  handleRegisteredChange(e) {
    if (e.target.checked) {
      this.makePrimaryUser();
    }
    this.setState({ isRegistered: e.target.checked });
  }


  makePrimaryUser() {
    const postObject = {
      header: this.header,
      appuser: {
        id: this.state.id,
      },
    };
    FetchServerData.callPostService("/appuserms/makePrimaryUser", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let userDetails = output.data.appuser;
          let getPermission = Utils.getRolePermission(
            output.data?.privilegeList
          );
          let getUpdatePermission = getPermission[3];
          let getDeletePermission = getPermission[4];
          let userStatus = "";
          if (userStatus === null) {
            userStatus = false;
          } else {
            if (userDetails.appuserStatus?.status === "Active") {
              userStatus = true;
            } else {
              userStatus = false;
            }
          }
          let phoneNo =
            userDetails?.phone !== null
              ? Utils.phoneNumberFormate(userDetails?.phone)
              : "";
          let officePhoneNo =
            userDetails?.officePhone !== null
              ? Utils.phoneNumberFormate(userDetails?.officePhone)
              : "";
          this.setState({
            id: userDetails.id,
            firstName: userDetails.firstName,
            lastName: userDetails.lastName,
            uid: userDetails.uid,
            email: userDetails.email,
            countryCode: userDetails.phoneCountrycode,
            officeCountryCode: userDetails.officePhoneCountrycode,
            phone: userDetails?.phone,
            phoneNo: phoneNo,
            officePhoneNo: officePhoneNo,
            officePhone: userDetails?.officePhone,
            jobTitle: userDetails.jobTitle,
            designation: userDetails.designation,
            enablemobileaccess: userDetails.enablemobileaccess,
            isSendReceipt: userDetails.isSendReceipt,
            sendOtpByEmail: userDetails.sendOtpByEmail,
            sendOtpByText: userDetails.sendOtpByText,
            address: userDetails.address,
            userProfile: userDetails.profile,
            isStatus: userStatus,
            userStatus: userDetails.appuserStatus?.status,
            isPwdresetRequested: userDetails.isPwdresetRequested,
            getUpdatePermission: getUpdatePermission,
            getDeletePermission: getDeletePermission,
          });
        } else {
        }
      })
      .catch((error) => { });
  }


  requestToMakePrimaryUser() {
    const postObject1 = {
      header: this.header,
      appuser: {
        id: this.state.id
      }
    };
    FetchServerData.callPostService(
      "/appuserms/requestToMakePrimaryUser",
      postObject1
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let userDetails = output.data.appuser;
        let userStatus = "";
        if (userStatus === null) {
          userStatus = false;
        } else {
          if (userDetails.appuserStatus?.status === "Active") {
            userStatus = true;
          } else {
            userStatus = false;
          }
        }
        let phoneNo =
          userDetails?.phone !== null
            ? Utils.phoneNumberFormate(userDetails?.phone)
            : "";
        let officePhoneNo =
          userDetails?.officePhone !== null
            ? Utils.phoneNumberFormate(userDetails?.officePhone)
            : "";
        let sendverificationCode = null
        if (userDetails.sendOtpByEmail && userDetails.sendOtpByText) {
          sendverificationCode = {
            name: "SMS and Email",
            sendOtpByText: true,
            sendOtpByEmail: true,
            id: 3
          };
        } else if (userDetails.sendOtpByText) {
          sendverificationCode = {
            name: "SMS",
            sendOtpByText: true,
            sendOtpByEmail: false,
            id: 1
          };
        } else if (userDetails.sendOtpByEmail) {
          sendverificationCode = {
            name: "Email",
            sendOtpByText: false,
            sendOtpByEmail: true,
            id: 2
          };
        }
        this.setState({
          id: userDetails.id,
          firstName: userDetails.firstName,
          lastName: userDetails.lastName,
          uid: userDetails.uid,
          email: userDetails.email,
          countryCode: userDetails.phoneCountrycode,
          officeCountryCode: userDetails.officePhoneCountrycode,
          phone: userDetails?.phone,
          phoneNo: phoneNo,
          officePhoneNo: officePhoneNo,
          officePhone: userDetails?.officePhone,
          jobTitle: userDetails.jobTitle,
          designation: userDetails.designation,
          enablemobileaccess: userDetails.enablemobileaccess,
          isRegistered: userDetails.isRegistered,
          isSendReceipt: userDetails.isSendReceipt,
          sendOtpByEmail: userDetails.sendOtpByEmail,
          sendOtpByText: userDetails.sendOtpByText,
          sendverificationCode: sendverificationCode,
          address: userDetails.address,
          userProfile: userDetails.profile,
          isStatus: userStatus,
          userStatus: userDetails.appuserStatus?.status,
          isPwdresetRequested: userDetails.isPwdresetRequested,
          isMakePrimaryRequested: userDetails.isMakePrimaryRequested,
        });
      } else {
      }
    });
  }

  approveMakePrimaryUserToBackend() {
    const postObject1 = {
      header: this.header,
      appuser: {
        id: this.state.id
      }
    };
    FetchServerData.callPostService(
      "/appuserms/makePrimaryUser",
      postObject1
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let userDetails = output.data.appuser;
        let userStatus = "";
        if (userStatus === null) {
          userStatus = false;
        } else {
          if (userDetails.appuserStatus?.status === "Active") {
            userStatus = true;
          } else {
            userStatus = false;
          }
        }
        let phoneNo =
          userDetails?.phone !== null
            ? Utils.phoneNumberFormate(userDetails?.phone)
            : "";
        let officePhoneNo =
          userDetails?.officePhone !== null
            ? Utils.phoneNumberFormate(userDetails?.officePhone)
            : "";
        let sendverificationCode = null
        if (userDetails.sendOtpByEmail && userDetails.sendOtpByText) {
          sendverificationCode = {
            name: "SMS and Email",
            sendOtpByText: true,
            sendOtpByEmail: true,
            id: 3
          };
        } else if (userDetails.sendOtpByText) {
          sendverificationCode = {
            name: "SMS",
            sendOtpByText: true,
            sendOtpByEmail: false,
            id: 1
          };
        } else if (userDetails.sendOtpByEmail) {
          sendverificationCode = {
            name: "Email",
            sendOtpByText: false,
            sendOtpByEmail: true,
            id: 2
          };
        }
        this.setState({
          id: userDetails.id,
          firstName: userDetails.firstName,
          lastName: userDetails.lastName,
          uid: userDetails.uid,
          email: userDetails.email,
          countryCode: userDetails.phoneCountrycode,
          officeCountryCode: userDetails.officePhoneCountrycode,
          phone: userDetails?.phone,
          phoneNo: phoneNo,
          officePhoneNo: officePhoneNo,
          officePhone: userDetails?.officePhone,
          jobTitle: userDetails.jobTitle,
          designation: userDetails.designation,
          enablemobileaccess: userDetails.enablemobileaccess,
          isRegistered: userDetails.isRegistered,
          isSendReceipt: userDetails.isSendReceipt,
          sendOtpByEmail: userDetails.sendOtpByEmail,
          sendOtpByText: userDetails.sendOtpByText,
          sendverificationCode: sendverificationCode,
          address: userDetails.address,
          userProfile: userDetails.profile,
          isStatus: userStatus,
          userStatus: userDetails.appuserStatus?.status,
          isPwdresetRequested: userDetails.isPwdresetRequested,
          isMakePrimaryRequested: userDetails.isMakePrimaryRequested,
        });
      } else {
      }
    });
  }
  rejectMakePrimaryUserToBackend() {
    const postObject1 = {
      header: this.header,
      appuser: {
        id: this.state.id
      }
    };
    FetchServerData.callPostService(
      "/appuserms/rejectPrimaryUserRequest",
      postObject1
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let userDetails = output.data.appuser;
        let userStatus = "";
        if (userStatus === null) {
          userStatus = false;
        } else {
          if (userDetails.appuserStatus?.status === "Active") {
            userStatus = true;
          } else {
            userStatus = false;
          }
        }
        let phoneNo =
          userDetails?.phone !== null
            ? Utils.phoneNumberFormate(userDetails?.phone)
            : "";
        let officePhoneNo =
          userDetails?.officePhone !== null
            ? Utils.phoneNumberFormate(userDetails?.officePhone)
            : "";
        let sendverificationCode = null
        if (userDetails.sendOtpByEmail && userDetails.sendOtpByText) {
          sendverificationCode = {
            name: "SMS and Email",
            sendOtpByText: true,
            sendOtpByEmail: true,
            id: 3
          };
        } else if (userDetails.sendOtpByText) {
          sendverificationCode = {
            name: "SMS",
            sendOtpByText: true,
            sendOtpByEmail: false,
            id: 1
          };
        } else if (userDetails.sendOtpByEmail) {
          sendverificationCode = {
            name: "Email",
            sendOtpByText: false,
            sendOtpByEmail: true,
            id: 2
          };
        }
        this.setState({
          id: userDetails.id,
          firstName: userDetails.firstName,
          lastName: userDetails.lastName,
          uid: userDetails.uid,
          email: userDetails.email,
          countryCode: userDetails.phoneCountrycode,
          officeCountryCode: userDetails.officePhoneCountrycode,
          phone: userDetails?.phone,
          phoneNo: phoneNo,
          officePhoneNo: officePhoneNo,
          officePhone: userDetails?.officePhone,
          jobTitle: userDetails.jobTitle,
          designation: userDetails.designation,
          enablemobileaccess: userDetails.enablemobileaccess,
          isRegistered: userDetails.isRegistered,
          isSendReceipt: userDetails.isSendReceipt,
          sendOtpByEmail: userDetails.sendOtpByEmail,
          sendOtpByText: userDetails.sendOtpByText,
          sendverificationCode: sendverificationCode,
          address: userDetails.address,
          userProfile: userDetails.profile,
          isStatus: userStatus,
          userStatus: userDetails.appuserStatus?.status,
          isPwdresetRequested: userDetails.isPwdresetRequested,
          isMakePrimaryRequested: userDetails.isMakePrimaryRequested,
        });
      } else {
      }
    });
  }

  render() {
    if (this.state.action === "create") {
      return this.createUser();
    } else if (this.state.action === "edit") {
      return this.editUser();
    } else if (this.state.action === "view") {
      return this.viewUser();
    } else {
      return <UserManagementList action="userList" />;
    }
  }

  createUser() {
    // const { error, passwordFocussed } = this.state;
    const validCountryCodes = this.countryListArray
      ?.filter((country) => ["US", "CA", "AU", "IN"].includes(country.code))
      .map((country) => country.code.toLowerCase());
    const enableCountryCode = process.env.REACT_APP_ENABLE_COUNTRYCODE === "true";
    return (
      <div className="row mt-2">
        <ValidatorForm
          className="text-start"
          ref="form"
          onSubmit={this.createUserToBackend.bind(this)}
        >
          <div className="row">
            <div className="col-md-6">
              <div className="card " id="giveBeeCardTopBoxShadowremove">
                <div
                  className="card-header d-flex align-items-center justify-content-between"
                  id="assetCardHeader"
                >
                  <h6 className="mb-0" id="headerLabel">
                    <b>New User Details</b>
                  </h6>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6" id="assetFormLabel">
                      <label
                        className="form-label "
                        htmlFor="collapsible-firstname"
                      >
                        First Name*
                      </label>
                      <input
                        title=""
                        required
                        autoFocus={true}
                        type="text"
                        autoComplete="off"
                        id="multiStepsFirstName"
                        name="multiStepsFirstName"
                        className="form-control"
                        value={this.state.firstName}
                        onChange={this.handleFirstNameChange.bind(this)}
                        validators={["required"]}
                      // errormessages={["This field is required"]}
                      />
                    </div>
                    <div className="col-md-6" id="assetFormLabel">
                      <label
                        className="form-label "
                        htmlFor="collapsible-lastname"
                      >
                        Last Name*
                      </label>
                      <input
                        required
                        title=""
                        type="text"
                        autoComplete="off"
                        id="multiStepsFirstName"
                        name="multiStepsFirstName"
                        className="form-control"
                        value={this.state.lastName}
                        onChange={this.handleLastNameChange.bind(this)}
                        validators={["required"]}
                      // errormessages={["This field is required"]}
                      />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-6" id="assetFormLabel">
                      <label
                        className="form-label "
                        htmlFor="collapsible-email"
                      >
                        User ID{" "}
                        <span className="fw-normal">(email address)*</span>
                      </label>
                      <input
                        required
                        title=""
                        type="email"
                        autoComplete="off"
                        id="multiStepsFirstName"
                        name="multiStepsFirstName"
                        className="form-control"
                        value={this.state.email}
                        onChange={this.handleEmailChange.bind(this)}
                        validators={["required", "isEmail"]}
                        errormessages={[
                          "This field is required",
                          "Email id is not valid",
                        ]}
                      />
                    </div>
                    <div className="col-md-6" id="assetFormLabel">
                      <label
                        className="form-label"
                        htmlFor="collapsible-jotitle"
                      >
                        Job Title*
                      </label>
                      <input
                        required
                        title=""
                        type="text"
                        autoComplete="off"
                        id="multiStepsFirstName"
                        name="multiStepsFirstName"
                        className="form-control"
                        value={this.state.jobTitle}
                        onChange={this.handleJobTitleChange.bind(this)}
                        validators={["required"]}
                        errormessages={["This field is required"]}
                      />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-6" id="assetFormLabel">
                      <label
                        className="form-label "
                        htmlFor="collapsible-phone"
                      >
                        Mobile No*
                      </label>
                      {enableCountryCode ?
                        <span className="d-flex userPhoneInput">
                          <PhoneInput
                            country={this.defaultCountry?.code
                              ?.toString()
                              ?.toLowerCase()}
                            onlyCountries={validCountryCodes}
                            value={this.state.countryCode}
                            onChange={(phone, country, e, formattedValue) => {
                              this.handleCountryChange(
                                phone,
                                country,
                                e,
                                formattedValue
                              );
                            }}
                            autoFormat
                            countryCodeEditable={false}
                            disableCountryGuess={false}
                            enableSearch={true}
                            alwaysDefaultMask={true}
                          />
                          <input
                            required
                            title=""
                            type="text"
                            autoComplete="off"
                            name="multiStepsFirstName"
                            className="form-control"
                            value={this.state.phoneNo}
                            onChange={this.handlePhoneChange.bind(this)}
                            validators={["required"]}
                            errormessages={["This field is required"]}
                            onInvalid={(e) => {
                              e.target.setCustomValidity(
                                "Mobile number required"
                              );
                            }}
                            onInput={(e) => {
                              e.target.setCustomValidity("");
                            }}
                          />
                        </span>
                        :
                        <input
                          required
                          title=""
                          type="text"
                          autoComplete="off"
                          name="multiStepsFirstName"
                          className="form-control"
                          value={this.state.phoneNo}
                          onChange={this.handlePhoneChange.bind(this)}
                          validators={["required"]}
                          errormessages={["This field is required"]}
                          onInvalid={(e) => {
                            e.target.setCustomValidity(
                              "Mobile number required"
                            );
                          }}
                          onInput={(e) => {
                            e.target.setCustomValidity("");
                          }}
                        />
                      }
                    </div>
                    <div className="col-md-6" id="assetFormLabel">
                      <label
                        className="form-label "
                        htmlFor="collapsible-officephone"
                      >
                        Office Phone No
                      </label>
                      {enableCountryCode ?
                        <span className="d-flex userPhoneInput">
                          <PhoneInput
                            country={this.defaultCountry?.code
                              ?.toString()
                              ?.toLowerCase()}
                            onlyCountries={validCountryCodes}
                            value={this.state.officeCountryCode}
                            onChange={(phone, country, e, formattedValue) => {
                              this.handleOfficeCountryChange(
                                phone,
                                country,
                                e,
                                formattedValue
                              );
                            }}
                            autoFormat
                            countryCodeEditable={false}
                            disableCountryGuess={false}
                            enableSearch={true}
                            alwaysDefaultMask={true}
                          />
                          <input
                            title=""
                            type="text"
                            autoComplete="off"
                            id="multiStepsFirstName"
                            name="multiStepsFirstName"
                            className="form-control"
                            value={this.state.officePhoneNo}
                            onChange={this.handleOfficePhoneChange.bind(this)}
                            validators={["required"]}
                            errormessages={["This field is required"]}
                          />
                        </span>
                        :
                        <input
                          title=""
                          type="text"
                          autoComplete="off"
                          id="multiStepsFirstName"
                          name="multiStepsFirstName"
                          className="form-control"
                          value={this.state.officePhoneNo}
                          onChange={this.handleOfficePhoneChange.bind(this)}
                          validators={["required"]}
                          errormessages={["This field is required"]}
                        />
                      }
                    </div>
                  </div>
                  {/* <div className="row mt-3">
                    <div className="col-md-12 checkboxSize" id="assetFormLabel">
                      <FormControlLabel
                        style={{
                          width: "210px",
                          margin: "0",
                          padding: "0",
                          height: "15px",
                        }}
                        control={
                          <Checkbox
                            variant="outlined"
                            id="isAsset"
                            checked={this.state.isRegistered}
                            value={this.state.isRegistered}
                            onChange={this.handleRegisteredChange.bind(
                              this
                            )}
                            style={{
                              background: "none",
                            }}
                          />
                        }
                        label={
                          <span className="form-label fw-normal ps-1">
                            Make Primary User
                          </span>
                        }
                      />
                    </div>
                  </div> */}
                </div >
              </div >
            </div >
            <div className="col-md-6">
              <div className="card" id="giveBeeCardTopBoxShadowremove">
                <div
                  className="card-header d-flex align-items-center justify-content-between"
                  id="assetCardHeader"
                >
                  <h6 className="mb-0" id="headerLabel">
                    <b>New User Login Settings</b>
                  </h6>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6" id="assetFormLabel">
                      <label
                        className="form-label MuiAutocomplete-label"
                        htmlFor="collapsible-userProfile"
                      >
                        User Type*
                      </label>

                      <Autocomplete
                        id="size-small-outlined"
                        size="small"
                        fullWidth
                        disableClearable
                        autoComplete="off"
                        ListboxProps={{
                          className: "custom-listbox",
                        }}
                        options={this.state.userProfileList}
                        value={this.state.userProfile}
                        getOptionLabel={(option) => option.name}
                        defaultValue={this.state.userProfile}
                        onChange={(event, value) => {
                          this.handleUserProfileChange(value);
                        }}
                        inputprops={{
                          style: { textTransform: "capitalize" },
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            title=""
                            placeholder="Please Select"
                            variant="outlined"
                            size="small"
                            className="autoComplete"
                            style={{ background: "#fff" }}
                          // helperText={this.state.userProfile?.description}
                          />
                        )}
                      />
                    </div>
                    <div
                      className="col-md-6 pe-0 align-self-end"
                      id="assetFormLabel"
                    >
                      <div className="row">
                        <div className="col-md-12" >
                          <span
                            style={{ fontSize: "11px", textAlign: "justify" }}
                          >
                            {this.state.userProfile?.description}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row mt-3">
                    <div className="col-md-12" >
                      <p className="mb-0">
                        A login link and temporary password will be emailed to this new user.
                      </p>
                    </div>
                    {/* <div className="col-md-6 form-password-toggle">
                      <label className="form-label" htmlFor="multiStepsPass">
                        Password*
                        {this.state.passwordHelperText ? (
                          <PasswordRequirementsTooltip
                            error={error}
                            open={passwordFocussed}
                            style={{
                              float: "right",
                              marginTop: "-1em",
                            }}
                          />
                        ) : (
                          ""
                        )}{" "}
                      </label>
                      <div className="input-group input-group-merge">
                        <input
                          type={this.state.showPassword ? "text" : "password"}
                          title=""
                          id="password"
                          name="password"
                          className="form-control"
                          aria-describedby="multiStepsPass2"
                          onChange={this.handlePasswordChange.bind(this)}
                          value={this.state.password}
                          onFocus={this.toggleFocusNewPassword}
                          onBlur={this.toggleFocusNewPassword}
                          helperText={this.state.passwordHelperText}
                          error={this.state.passwordHelperText !== ""}
                        />
                        <span
                          className="input-group-text cursor-pointer"
                          id="multiStepsPass2"
                          onClick={this.handleClickShowPassword.bind(this)}
                        >
                          {this.state.showPassword ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-6 form-password-toggle">
                      <label
                        className="form-label"
                        htmlFor="multiStepsConfirmPass"
                      >
                        Confirm Password*
                      </label>
                      <div className="input-group input-group-merge">
                        <input
                          title=""
                          id="confirmPassword"
                          name="confirmPassword"
                          className="form-control"
                          aria-describedby="multiStepsConfirmPass2"
                          value={this.state.confirmPassword}
                          type={this.state.showConfirmPassword ? "text" : "password"}
                          helperText={this.state.confirmPasswordHelperText}
                          error={this.state.confirmPasswordHelperText !== ""}
                          onChange={this.handlePasswordChange.bind(this)}
                        />
                        <span
                          className="input-group-text cursor-pointer"
                          id="multiStepsConfirmPass2"
                          onClick={this.handleClickShowConfirmPassword.bind(
                            this
                          )}
                        >
                          {this.state.showConfirmPassword ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </span>
                      </div>
                      {this.state.confirmPasswordHelperText !== "" && (
                        <p style={{ color: "red", fontSize: "13px" }}>
                          {this.state.confirmPasswordHelperText}
                        </p>
                      )}
                    </div> */}
                  </div>
                  <div className="row mt-4">
                    <div className="col-md-6 d-flex" id="assetFormLabel">
                      <label
                        className="form-label "
                        htmlFor="collapsible-email"
                      >
                        Email Receipts
                      </label>
                      <br></br>
                      <span className="ms-4">
                        <label class="switch">
                          <input
                            type="checkbox"
                            checked={this.state.isSendReceipt}
                            value={this.state.isSendReceipt}
                            onChange={this.handleIsSendReceiptChange.bind(
                              this
                            )}
                          />
                          <span class="slider round"></span>
                        </label>
                      </span>
                    </div>
                  </div>
                  <div className="row mt-4">
                    <div className="col-sm-12">
                      <div className="row">
                        <label
                          className="form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Two-factor Authentication
                          <InfoTooltip
                            data="This Two-Factor Authentication feature provides you with higher-level of account security by requiring that you enter a unique password after you correctly enter your login ID and password. The unique password is delivered to your mobile phone, by text message, each time you log in.
                            The use of Two-Factor Authentication is recommended."
                            style={{
                              float: "right",
                            }}
                          />
                        </label>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-6" id="assetFormLabel">
                          <label
                            className="form-label MuiAutocomplete-label"
                            htmlFor="collapsible-userProfile"
                          >
                            Send verification code as
                          </label>

                          <Autocomplete
                            id="size-small-outlined"
                            size="small"
                            fullWidth
                            disableClearable
                            autoComplete="off"
                            ListboxProps={{
                              className: "custom-listbox",
                            }}
                            options={this.state.sendverificationCodeList}
                            value={this.state.sendverificationCode}
                            getOptionLabel={(option) => option.name}
                            defaultValue={this.state.sendverificationCode}
                            onChange={(event, value) => {
                              this.handleSendverificationCodeChange(value);
                            }}
                            inputprops={{
                              style: { textTransform: "capitalize" },
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                title=""
                                placeholder="Please Select"
                                variant="outlined"
                                size="small"
                                className="autoComplete"
                                style={{ background: "#fff" }}
                              // helperText={this.state.userProfile?.description}
                              />
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {this.businessDomain === BUSINESS_DOMAIN.eventText &&
                    <div className="row mt-3">
                      <div className="col-md-6 d-flex" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-email"
                        >
                          Mobile App Access
                        </label>
                        <br></br>
                        <span className="ms-4">
                          {/* {this.state.enablemobileaccess ? (
                            <ToggleButton
                              value="Yes"
                              className="ToggleButtonActive"
                              onChange={this.handleEnableMobileAccessChange.bind(
                                this
                              )}
                              style={{
                                background: "#37517e",
                                color: "#ffff",
                                height: "25px",
                                width: "60px",
                                borderRadius: "5px",
                                textTransform: "none",
                              }}
                            >
                              YES
                            </ToggleButton>
                          ) : (
                            <ToggleButton
                              value="No"
                              className="ToggleButtonActive"
                              onChange={this.handleEnableMobileAccessChange.bind(
                                this
                              )}
                              style={{
                                background: "#D7DBDD",
                                color: "#000",
                                height: "25px",
                                width: "60px",
                                borderRadius: "5px",
                                textTransform: "none",
                              }}
                            >
                              NO
                            </ToggleButton>
                          )} */}
                          <label class="switch">
                            <input
                              type="checkbox"
                              checked={this.state.enablemobileaccess}
                              value={this.state.enablemobileaccess}
                              onChange={this.handleEnableMobileAccessChange.bind(
                                this
                              )}
                            />
                            <span class="slider round"></span>
                          </label>
                        </span>
                      </div>
                    </div>
                  }
                </div >
              </div >
            </div >
          </div >
          <div className="row d-flex align-items-center justify-content-between">
            <div className="col-sm-12 mt-4 text-center">
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: this.state.isHovered ? "#006600" : "green",
                  color: "#fff",
                  marginRight: "1rem",
                  fontWeight: "bold",
                  textTransform: "capitalize",
                  padding:
                    this.state.pageId === "Message" ? "4px 12px" : "2px 10px",
                }}
                startIcon={<CheckIcon style={{ fontSize: "16px" }} />}
                onMouseEnter={() => this.setState({ isHovered: true })}
                onMouseLeave={() => this.setState({ isHovered: false })}
              >
                Add User
              </Button>
              &nbsp;&nbsp;
              <CancelIconButton onClick={(e) => this.createCancel()} />
            </div>
          </div>
        </ValidatorForm >
      </div >
    );
  }

  viewUser() {
    const enableCountryCode = process.env.REACT_APP_ENABLE_COUNTRYCODE === "true";

    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <>
          <div className="row" style={{ width: "100%" }}>
            <div className="col-md-6"></div>
            <div className="col-md-6">
              {this.state.getDeletePermission && (
                // <DeleteIconButton
                //   domainObject={
                //     this.state.firstName + " " + this.state.lastName
                //   }
                //   pageId="User"
                //   onClick={this.deleteUserToBackend.bind(this)}
                // />
                <Button
                  variant="contained"
                  style={{
                    background: "#d3d8de",
                    color: "#353538",
                    // marginRight: "1rem",
                    float: "right",
                    textTransform: "capitalize",
                    padding: "2px 10px",
                  }
                  }
                  startIcon={
                    <i
                      class="fa-regular fa-trash-can"
                      aria-hidden="true"
                      style={{ fontSize: "14px", fontWeight: "600" }}
                    ></i>
                  }
                  onClick={this.handleUserDeleteConfirmOpen.bind(this)}
                >
                  Delete
                </Button>
              )}
              {this.state.getUpdatePermission && (
                <EditIconButton onClick={this.editUserDetails.bind(this)} />
              )}
            </div>
          </div >
          <div className="row" style={{ padding: "1em" }}>
            <div className="col-md-6">
              <div className="card" id="giveBeeCardTopBoxShadowremove">
                <div
                  className="card-header d-flex align-items-center justify-content-between"
                  id="assetCardHeader"
                >
                  <h6 className="mb-0" id="headerLabel">
                    <b>User Details</b>
                  </h6>
                </div>
                <div className="card-body">
                  <div className="row">
                    <label
                      className="col-sm-4 col-form-label fw-bold"
                      htmlFor="basic-default-name"
                      id="assetFormLabel"
                    >
                      Name
                    </label>
                    <div className="col-sm-8" id="givbeeText">
                      <span>
                        {this.state.firstName + " " + this.state.lastName}
                      </span>
                    </div>
                  </div>
                  <div className="row">
                    <label
                      className="col-sm-4 col-form-label fw-bold"
                      htmlFor="basic-default-name"
                      id="assetFormLabel"
                    >
                      Job title
                    </label>
                    <div className="col-sm-8" id="givbeeText">
                      <span>{this.state.jobTitle}</span>
                    </div>
                  </div>
                  <div className="row">
                    <label
                      className="col-sm-4 col-form-label fw-bold"
                      htmlFor="basic-default-email"
                      id="assetFormLabel"
                    >
                      User ID{" "}
                      <span className="fw-normal">(email address)</span>
                    </label>
                    <div className="col-sm-8" id="givbeeText">
                      <span>{this.state.email}</span>
                    </div>
                  </div>
                  <div className="row">
                    <label
                      className="col-sm-4 col-form-label fw-bold"
                      htmlFor="basic-default-name"
                      id="assetFormLabel"
                    >
                      Mobile Number
                    </label>
                    <div className="col-sm-8" id="givbeeText">
                      <span>
                        {enableCountryCode ? `${this.state.countryCode || "+1"} ${Utils.viewPhoneNumberFormate(this.state.phoneNo)}` : Utils.viewPhoneNumberFormate(this.state.phoneNo)}
                      </span>
                    </div>
                  </div>
                  <div className="row">
                    <label
                      className="col-sm-4 col-form-label fw-bold"
                      htmlFor="basic-default-name"
                      id="assetFormLabel"
                    >
                      Office Phone
                    </label>
                    <div className="col-sm-8" id="givbeeText">
                      <span>
                        {enableCountryCode ?
                          `${this.state.officePhoneNo
                            ? (this.state.officeCountryCode || "+1")
                            : ""
                          } ${Utils.viewPhoneNumberFormate(this.state.officePhoneNo)}` : Utils.viewPhoneNumberFormate(this.state.officePhoneNo)}
                      </span>
                    </div>
                  </div>
                  <div className="row">
                    {this.state.userProfile?.name === "Admin" && (this.appuser?.isRegistered || this.header?.isAp) &&
                      <>
                        {!this.state.isMakePrimaryRequested &&
                          <>
                            <label
                              className="col-sm-4 col-form-label fw-bold"
                              htmlFor="basic-default-name"
                              id="assetFormLabel"
                            >
                              Primary User
                            </label>
                            <div className="col-sm-8" id="givbeeText">
                              {this.state.isRegistered === false ?
                                <span
                                  className="cursor-pointer anchortag pt-2"
                                  style={{ fontSize: "14px" }}
                                  onClick={this.requestToMakePrimaryUser.bind(
                                    this
                                  )}
                                >
                                  <u>Request to make this user as Primary Admin user.</u>
                                </span> :
                                <span>
                                  Yes
                                </span>
                              }
                            </div>
                          </>
                        }
                      </>
                    }
                    {(this.state.userProfile?.name === "Admin" && !this.state.isRegistered && this.header?.isAp) && (
                      <>
                        {this.state.isMakePrimaryRequested &&
                          <>
                            <label
                              className="col-sm-4 col-form-label fw-bold"
                              htmlFor="basic-default-name"
                              id="assetFormLabel"
                            >
                              Primary User
                            </label>
                            <div className="col-sm-8" id="givbeeText">
                              <Button
                                type="button"
                                variant="contained"
                                id="ptsButton"
                                style={{
                                  background: "green",
                                  marginRight: "1rem",
                                  color: "#fff",
                                  fontWeight: "bold",
                                  textTransform: "capitalize",
                                  padding: "2px 10px",
                                }}
                                onClick={this.approveMakePrimaryUserToBackend.bind(
                                  this
                                )}
                              >
                                Approve
                              </Button>
                              <Button
                                type="button"
                                variant="contained"
                                id="ptsButton"
                                // startIcon={<CloseIcon />}
                                onClick={this.rejectMakePrimaryUserToBackend.bind(
                                  this
                                )}
                              >
                                Deny
                              </Button>
                            </div>
                          </>
                        }
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card " id="giveBeeCardTopBoxShadowremove">
                <div
                  className="card-header d-flex align-items-center justify-content-between"
                  id="assetCardHeader"
                >
                  <h6 className="mb-0" id="headerLabel">
                    <b>User Settings</b>
                  </h6>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-12" id="givbeeText">
                      {/* <span>
                        {Utils.getAddressAsText(
                          this.state.address !== null
                            ? this.state.address
                            : null
                        )}
                      </span> */}
                      <div className="row">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          User Type
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          {this.state.userProfile && (
                            <>
                              <span>{this.state.userProfile.name}</span> &nbsp;
                              <span
                                style={{ fontSize: "12px" }}
                              >{`(${this.state.userProfile?.description})`}</span>
                            </>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Email Receipts
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          <span>{this.state.isSendReceipt ? "Yes" : "No"}</span>
                        </div>
                      </div>
                      <div className="row">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          User Status
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          <span>{this.state.userStatus}</span>
                        </div>
                      </div>
                      <div className="row">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Send verification code as
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          <span>
                            {this.state.sendOtpByText &&
                              this.state.sendOtpByEmail
                              ? "SMS, Email"
                              : this.state.sendOtpByText
                                ? "SMS"
                                : this.state.sendOtpByEmail
                                  ? "Email"
                                  : ""}
                          </span>
                        </div>
                      </div>
                      {this.businessDomain === BUSINESS_DOMAIN.eventText &&
                        <div className="row">
                          <label
                            className="col-sm-4 col-form-label fw-bold"
                            htmlFor="basic-default-name"
                            id="assetFormLabel"
                          >
                            Mobile App Access
                          </label>
                          <div className="col-sm-8" id="givbeeText">
                            <span>
                              {this.state.enablemobileaccess === true
                                ? "YES"
                                : "NO"}
                            </span>
                          </div>
                        </div>
                      }
                      {!(
                        ["Manager", "Sender", "Creator"].includes(
                          this.profile?.name
                        ) || this.state.userProfile?.name === "Admin"
                      ) && (
                          <div className="row">
                            <label
                              className="col-sm-4 col-form-label fw-bold"
                              htmlFor="basic-default-name"
                              id="assetFormLabel"
                            >
                              Request password Reset
                            </label>
                            <div className="col-sm-8" id="givbeeText">
                              <label class="switch">
                                <input
                                  type="checkbox"
                                  checked={this.state.isPwdresetRequested}
                                  value={this.state.isPwdresetRequested}
                                  onChange={this.handlePwdresetRequestedChange.bind(
                                    this
                                  )}
                                />
                                <span class="slider round"></span>
                              </label>
                            </div>
                          </div>
                        )}

                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-4 text-start">
              <BackButton
                type="button"
                style={{ backgroundColor: "#162c50", color: "#fff" }}
                variant="contained"
                onClick={(e) => this.viewCancel()}
              >
                Back
              </BackButton>
            </div>
          </div>
          <Dialog
            open={this.state.userDeleteConfirmOpen}
            onClose={this.handleUserDeleteConfirmClose.bind(this)}
            onHide={this.close}
            style={{ padding: "1em" }}
          >
            <DialogContent>
              <span style={{ textAlign: "center" }}>
                {this.appuser?.email === this.state.email ?
                  <p className="m-0" style={{ fontSize: "17px", lineHeight: "1.3em" }}>
                    You are about to permanently delete yourself. You will not be part of this account anymore.
                  </p>
                  :
                  <p className="m-0" style={{ fontSize: "17px", lineHeight: "1.3em" }}>
                    You are about to permanently delete the user {" "}
                    <span
                      style={{
                        color: " #37517e",
                        fontWeight: "bold",
                        fontSize: "16px",
                      }}
                    >
                      “{this.state.firstName + " " + this.state.lastName}”.
                    </span>
                  </p>
                }
              </span>
              <Row className="mt-4">
                <span style={{ textAlign: "center" }}>
                  <h2 style={{ fontSize: "20px" }}>Please enter your Password.</h2>
                </span>
                <Col md={6} style={{ marginLeft: "auto", marginRight: "auto" }}>
                  <div className="input-group input-group-merge">
                    <input
                      type={this.state.showDeleteConfirmpassword ? "text" : "password"}
                      title=""
                      autoFocus={true}
                      id="password"
                      name="password"
                      className="form-control"
                      aria-describedby="multiStepsPass2"
                      onChange={this.handleUserDeleteConfirmPasswordChange.bind(this)}
                      value={this.state.deleteConfirmpassword}
                    />
                    <span
                      className="input-group-text cursor-pointer"
                      id="multiStepsPass2"
                      onClick={this.handleUserDeleteConfirmClickShowPassword.bind(this)}
                    >
                      {this.state.showDeleteConfirmpassword ? (
                        <VisibilityIcon />
                      ) : (
                        <VisibilityOffIcon />
                      )}
                    </span>
                  </div>
                </Col>
              </Row>
            </DialogContent>
            <DialogActions
              style={{ padding: "2em", marginLeft: "auto", marginRight: "auto" }}
            >
              <Button
                variant="contained"
                size="large"
                style={{
                  background: "#0B6F9D",
                  color: "#fff",
                  marginRight: "1rem",
                  padding: "2px 10px",
                  textTransform: "capitalize",
                }}
                startIcon={<SaveIcon />}
                onClick={(e) => this.deleteUserToBackend(e)}
              >
                Confirm
              </Button>
              <Button
                variant="contained"
                size="large"
                style={{
                  background: "#717373",
                  color: "#fff",
                  marginRight: "1rem",
                  padding: "2px 10px",
                  textTransform: "capitalize",
                }}
                startIcon={<CloseIcon />}
                onClick={this.handleUserDeleteConfirmClose.bind(this)}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        </>
      );
    }
  }
  editUser() {
    const validCountryCodes = this.countryListArray
      ?.filter((country) => ["US", "CA", "AU", "IN"].includes(country.code))
      .map((country) => country.code.toLowerCase());
    const enableCountryCode = process.env.REACT_APP_ENABLE_COUNTRYCODE === "true";
    return (
      <div className="row mt-2">
        <ValidatorForm
          className="text-start"
          ref="form"
          onSubmit={this.updateUserToBackend.bind(this)}
        >
          <div className="row">
            <div className="col-md-6">
              <div className="card " id="giveBeeCardTopBoxShadowremove">
                <div
                  className="card-header d-flex align-items-center justify-content-between"
                  id="assetCardHeader"
                >
                  <h6 className="mb-0" id="headerLabel">
                    <b>User Details</b>
                  </h6>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6" id="assetFormLabel">
                      <label
                        className="form-label "
                        htmlFor="collapsible-firstname"
                      >
                        First Name*
                      </label>
                      <input
                        required
                        title=""
                        type="text"
                        autoComplete="off"
                        id="multiStepsFirstName"
                        name="multiStepsFirstName"
                        className="form-control"
                        value={this.state.firstName}
                        onChange={this.handleFirstNameChange.bind(this)}
                        validators={["required"]}
                        errormessages={["This field is required"]}
                      />
                    </div>
                    <div className="col-md-6" id="assetFormLabel">
                      <label
                        className="form-label "
                        htmlFor="collapsible-lastname"
                      >
                        Last Name*
                      </label>
                      <input
                        required
                        title=""
                        type="text"
                        autoComplete="off"
                        id="multiStepsFirstName"
                        name="multiStepsFirstName"
                        className="form-control"
                        value={this.state.lastName}
                        onChange={this.handleLastNameChange.bind(this)}
                        validators={["required"]}
                        errormessages={["This field is required"]}
                      />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-6 mt-1" id="assetFormLabel">
                      <label
                        className="form-label "
                        htmlFor="collapsible-email"
                      >
                        User ID{" "}
                        <span className="fw-normal">(email address)*</span>
                      </label>
                      <input
                        required
                        title=""
                        type="email"
                        autoComplete="off"
                        id="multiStepsFirstName"
                        name="multiStepsFirstName"
                        className="form-control"
                        value={this.state.email}
                        onChange={this.handleEmailChange.bind(this)}
                        validators={["required", "isEmail"]}
                        errormessages={[
                          "This field is required",
                          "Email id is not valid",
                        ]}
                      />
                    </div>
                    <div className="col-md-6" id="assetFormLabel">
                      <label
                        className="form-label"
                        htmlFor="collapsible-panno"
                      >
                        Job Title*
                      </label>
                      <input
                        required
                        title=""
                        type="text"
                        autoComplete="off"
                        id="multiStepsFirstName"
                        name="multiStepsFirstName"
                        className="form-control"
                        value={this.state.jobTitle}
                        onChange={this.handleJobTitleChange.bind(this)}
                        validators={["required"]}
                        errormessages={["This field is required"]}
                      />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-6" id="assetFormLabel">
                      <label
                        className="form-label "
                        htmlFor="collapsible-phone"
                      >
                        Mobile No*
                      </label>
                      {enableCountryCode ?
                        <span className="d-flex userPhoneInput">
                          <PhoneInput
                            country={this.defaultCountry?.code
                              ?.toString()
                              ?.toLowerCase()}
                            onlyCountries={validCountryCodes}
                            value={this.state.countryCode}
                            onChange={(phone, country, e, formattedValue) => {
                              this.handleCountryChange(
                                phone,
                                country,
                                e,
                                formattedValue
                              );
                            }}
                            autoFormat
                            countryCodeEditable={false}
                            disableCountryGuess={false}
                            enableSearch={true}
                            alwaysDefaultMask={true}
                          />
                          <input
                            required
                            title=""
                            type="text"
                            autoComplete="off"
                            name="multiStepsFirstName"
                            className="form-control"
                            value={this.state.phoneNo}
                            onChange={this.handlePhoneChange.bind(this)}
                            validators={["required"]}
                            errormessages={["This field is required"]}
                          // onInvalid={(e) => {
                          //   e.target.setCustomValidity(
                          //     "Mobile number required"
                          //   );
                          // }}
                          />
                        </span>
                        :
                        <input
                          required
                          title=""
                          type="text"
                          autoComplete="off"
                          name="multiStepsFirstName"
                          className="form-control"
                          value={this.state.phoneNo}
                          onChange={this.handlePhoneChange.bind(this)}
                          validators={["required"]}
                          errormessages={["This field is required"]}
                        />
                      }
                    </div>
                    <div className="col-md-6" id="assetFormLabel">
                      <label
                        className="form-label "
                        htmlFor="collapsible-officephone"
                      >
                        Office Phone No
                      </label>
                      {enableCountryCode ?
                        <span className="d-flex userPhoneInput">
                          <PhoneInput
                            country={this.defaultCountry?.code
                              ?.toString()
                              ?.toLowerCase()}
                            onlyCountries={validCountryCodes}
                            value={this.state.officeCountryCode}
                            onChange={(phone, country, e, formattedValue) => {
                              this.handleOfficeCountryChange(
                                phone,
                                country,
                                e,
                                formattedValue
                              );
                            }}
                            autoFormat
                            countryCodeEditable={false}
                            disableCountryGuess={false}
                            enableSearch={true}
                            alwaysDefaultMask={true}
                          />
                          <input
                            title=""
                            type="text"
                            autoComplete="off"
                            id="multiStepsFirstName"
                            name="multiStepsFirstName"
                            className="form-control"
                            value={this.state.officePhoneNo}
                            onChange={this.handleOfficePhoneChange.bind(this)}
                            validators={["required"]}
                            errormessages={["This field is required"]}
                          />
                        </span>
                        :
                        <input
                          title=""
                          type="text"
                          autoComplete="off"
                          id="multiStepsFirstName"
                          name="multiStepsFirstName"
                          className="form-control"
                          value={this.state.officePhoneNo}
                          onChange={this.handleOfficePhoneChange.bind(this)}
                          validators={["required"]}
                          errormessages={["This field is required"]}
                        />
                      }
                    </div>
                  </div>
                  {/* <div className="row mt-3">
                    <div className="col-md-12 checkboxSize" id="assetFormLabel">
                      <FormControlLabel
                        style={{
                          width: "210px",
                          margin: "0",
                          padding: "0",
                          height: "15px",
                        }}
                        control={
                          <Checkbox
                            variant="outlined"
                            id="isAsset"
                            checked={this.state.isRegistered}
                            value={this.state.isRegistered}
                            onChange={this.handleRegisteredChange.bind(
                              this
                            )}
                            style={{
                              background: "none",
                            }}
                          />
                        }
                        label={
                          <span className="form-label fw-normal ps-1">
                            Make Primary User
                          </span>
                        }
                      />
                    </div>
                  </div> */}
                </div >
              </div >
            </div >
            <div className="col-md-6">
              <div className="card" id="giveBeeCardTopBoxShadowremove">
                <div
                  className="card-header d-flex align-items-center justify-content-between"
                  id="assetCardHeader"
                >
                  <h6 className="mb-0" id="headerLabel">
                    <b>User Settings</b>
                  </h6>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6" id="assetFormLabel">
                      <label
                        className="form-label MuiAutocomplete-label"
                        htmlFor="collapsible-userProfile"
                      >
                        User Type*
                      </label>

                      <Autocomplete
                        id="size-small-outlined"
                        size="small"
                        fullWidth
                        disableClearable
                        autoComplete="off"
                        ListboxProps={{
                          className: "custom-listbox",
                        }}
                        options={this.state.userProfileList}
                        value={this.state.userProfile}
                        getOptionLabel={(option) => option.name}
                        defaultValue={this.state.userProfile}
                        onChange={(event, value) => {
                          this.handleUserProfileChange(value);
                        }}
                        inputprops={{
                          style: { textTransform: "capitalize" },
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            title=""
                            placeholder="Please Select"
                            variant="outlined"
                            size="small"
                            className="autoComplete"
                            style={{ background: "#fff" }}
                          // helperText={this.state.userProfile?.description}
                          />
                        )}
                      />
                    </div>
                    <div
                      className="col-md-6 pe-0 align-self-end"
                      id="assetFormLabel"
                    >
                      <span
                        style={{ fontSize: "11px", textAlign: "justify" }}
                      >
                        {this.state.userProfile?.description}
                      </span>
                    </div>
                  </div>

                  <div className="row mt-4">
                    <div className="col-md-6 d-flex" id="assetFormLabel">
                      <label
                        className="form-label "
                        htmlFor="collapsible-email"
                      >
                        Email Receipts
                      </label>
                      <br></br>
                      <span className="ms-4">
                        <label class="switch">
                          <input
                            type="checkbox"
                            checked={this.state.isSendReceipt}
                            value={this.state.isSendReceipt}
                            onChange={this.handleIsSendReceiptChange.bind(
                              this
                            )}
                          />
                          <span class="slider round"></span>
                        </label>
                      </span>
                    </div>
                  </div>
                  <div className="row mt-4">
                    <div className="col-sm-12">
                      <div className="row">
                        <label
                          className="form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Two-factor Authentication
                          <InfoTooltip
                            data="This Two-Factor Authentication feature provides you with higher-level of account security by requiring that you enter a unique password after you correctly enter your login ID and password. The unique password is delivered to your mobile phone, by text message, each time you log in.
                            The use of Two-Factor Authentication is recommended."
                            style={{
                              float: "right",
                            }}
                          />
                        </label>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-6" id="assetFormLabel">
                          <label
                            className="form-label MuiAutocomplete-label"
                            htmlFor="collapsible-userProfile"
                          >
                            Send verification code as
                          </label>

                          <Autocomplete
                            id="size-small-outlined"
                            size="small"
                            fullWidth
                            disableClearable
                            autoComplete="off"
                            ListboxProps={{
                              className: "custom-listbox",
                            }}
                            options={this.state.sendverificationCodeList}
                            value={this.state.sendverificationCode}
                            getOptionLabel={(option) => option.name}
                            defaultValue={this.state.sendverificationCode}
                            onChange={(event, value) => {
                              this.handleSendverificationCodeChange(value);
                            }}
                            inputprops={{
                              style: { textTransform: "capitalize" },
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                title=""
                                placeholder="Please Select"
                                variant="outlined"
                                size="small"
                                className="autoComplete"
                                style={{ background: "#fff" }}
                              // helperText={this.state.userProfile?.description}
                              />
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {this.businessDomain === BUSINESS_DOMAIN.eventText &&
                    <div className="row mt-4">
                      <div className="col-md-6 d-flex" id="assetFormLabel">
                        <div className="row  d-flex">
                          <label
                            className="form-label col-sm-8"
                            htmlFor="collapsible-email"
                          >
                            Mobile App Access
                          </label>
                          <div className="col-sm-4">
                            {/* {this.state.enablemobileaccess ? (
                              <ToggleButton
                                value="Yes"
                                className="ToggleButtonActive"
                                onChange={this.handleEnableMobileAccessChange.bind(
                                  this
                                )}
                                style={{
                                  background: "#37517e",
                                  color: "#ffff",
                                  height: "25px",
                                  width: "60px",
                                  borderRadius: "5px",
                                  textTransform: "none",
                                }}
                              >
                                YES
                              </ToggleButton>
                            ) : (
                              <ToggleButton
                                value="No"
                                className="ToggleButtonActive"
                                onChange={this.handleEnableMobileAccessChange.bind(
                                  this
                                )}
                                style={{
                                  background: "#D7DBDD",
                                  color: "#000",
                                  height: "25px",
                                  width: "60px",
                                  borderRadius: "5px",
                                  textTransform: "none",
                                }}
                              >
                                NO
                              </ToggleButton>
                            )} */}
                            <label class="switch">
                              <input
                                type="checkbox"
                                checked={this.state.enablemobileaccess}
                                value={this.state.enablemobileaccess}
                                onChange={this.handleEnableMobileAccessChange.bind(
                                  this
                                )}
                              />
                              <span class="slider round"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 d-flex" id="assetFormLabel">
                        <div className="row d-flex">
                          <label
                            className="form-label col-sm-8"
                            htmlFor="collapsible-email"
                          >
                            User Status
                          </label>
                          <div className="col-sm-4">
                            <ToggleButton
                              value={
                                this.state.isStatus ? "Active" : "Inactive"
                              }
                              className="ToggleButtonActive"
                              onChange={this.handleStatusChange.bind(this)}
                              style={
                                this.state.isStatus
                                  ? {
                                    background: "#37517e",
                                    color: "#fff",
                                    height: "25px",
                                    width: "70px",
                                    borderRadius: "5px",
                                    textTransform: "none",
                                  }
                                  : {
                                    background: "#D7DBDD",
                                    color: "#000",
                                    height: "25px",
                                    width: "70px",
                                    borderRadius: "5px",
                                    textTransform: "none",
                                  }
                              }
                            >
                              {this.state.isStatus ? "Active" : "Inactive"}
                            </ToggleButton>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div >
          </div >
          <div className="row d-flex align-items-center justify-content-between">
            <div className="col-sm-12 mt-4 text-center">
              <SaveButton id="saveButton" type="submit">
                {" "}
                Save{" "}
              </SaveButton>
              &nbsp;&nbsp;
              <CancelIconButton onClick={(e) => this.editCancel()} />
            </div>
          </div>
        </ValidatorForm >
      </div >
    );
  }
}
export default withRouter(UserManagement);
